// extracted by mini-css-extract-plugin
export default {"cards":"bestOffers_cards__M-CSR"};